import { pb } from "lib/pocketbase";

async function getTeams() {
  try {
    let response = await pb.collection("teams").getFullList({
      sort: "created",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

async function getAnnualActivity() {
  try {
    let response = await pb.collection("annual_activity").getFullList({
      sort: "-created",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

async function getJourney() {
  try {
    let response = await pb.collection("journey").getFullList({
      sort: "created",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

async function getCompanyProfile() {
  try {
    let response = await pb.collection("company_profile").getFullList({
      sort: "created",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

async function getClients() {
  try {
    let response = await pb.collection("clients").getFullList({
      sort: "created",
      filter: `name_key = "about-partnership"`,
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

export {
  getTeams,
  getAnnualActivity,
  getJourney,
  getCompanyProfile,
  getClients,
};
